module.exports = __webpack_public_path__ + "static/img/3PL-services-small.4c7f9dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3PL-services-small.jpg
// module id = eJRL
// module chunks = 9